import { render, staticRenderFns } from "./CableTv.vue?vue&type=template&id=f7c2778a&scoped=true"
import script from "./CableTv.vue?vue&type=script&lang=js"
export * from "./CableTv.vue?vue&type=script&lang=js"
import style0 from "./CableTv.vue?vue&type=style&index=0&id=f7c2778a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c2778a",
  null
  
)

export default component.exports